/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_CopyInputs */



/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Developer_CopyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_copy = /** @type {((inputs?: Developer_CopyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_CopyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Copiar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia")
	return /** @type {LocalizedString} */ ("Copy")
});